import * as angular from 'angular';

export function ExtendedUibDropdownMenuDirective(): {
  restrict: string;
  require: string;
  link: (scope: angular.IScope, element: JQuery, attrs: angular.IAttributes, dropdownCtrl: any) => void;
} {
  return {
    restrict: 'A',
    require: '?^uibDropdown',
    link: function (scope, element, attrs, dropdownCtrl: any) {
      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
        return;
      }

      scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
        if (isOpen) {
          element.addClass('dropdown-open');
        } else {
          element.removeClass('dropdown-open');
        }
      });
    },
  };
}
